import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  motion,
  AnimatePresence,
  useScroll,
  useTransform,
} from "framer-motion";
import Footer from "../components/Footer";
import faqHero from "../assets/babouche1.jpg";
import textureBg from "../assets/texture-paper.jpg";
import { Link } from "react-router-dom";

const CategoryIcons = {
  Entretien: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 6h18" />
      <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
    </svg>
  ),
  Commande: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
      <path d="M3 6h18" />
      <path d="M16 10a4 4 0 01-8 0" />
      <path d="M10 14h4" />
    </svg>
  ),
  Tailles: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 3v3a2 2 0 01-2 2H3" />
      <path d="M21 8h-3a2 2 0 01-2-2V3" />
      <path d="M3 16h3a2 2 0 012 2v3" />
      <path d="M16 21v-3a2 2 0 012-2h3" />
      <path d="M4 12h16" />
      <path d="M12 4v16" />
    </svg>
  ),
  Matériaux: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2a10 10 0 00-7.38 16.75" />
      <path d="M12 2a10 10 0 017.38 16.75" />
      <path d="M8 12h8" />
      <path d="M12 16V8" />
      <path d="M12 22a10 10 0 100-20 10 10 0 000 20z" />
    </svg>
  ),
  Livraison: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2h6.5a1.5 1.5 0 011.5 1.5v17a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 015 20.5v-17A1.5 1.5 0 016.5 2H12z" />
      <path d="M12 2v6h6" />
      <path d="M9.5 14.5h5" />
      <path d="M9.5 17.5h5" />
      <path d="M19 8h2" />
    </svg>
  ),
  Personnalisation: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2a10 10 0 100 20 10 10 0 000-20z" />
      <path d="M8 12h8" />
      <path d="M12 16V8" />
      <path d="M12 2v2" />
      <path d="M12 20v2" />
      <path d="M20 12h2" />
      <path d="M2 12h2" />
      <path d="M18.36 5.64l1.42-1.42" />
      <path d="M4.22 19.78l1.42-1.42" />
    </svg>
  ),
  Fabrication: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 7h4a2 2 0 012 2v4" />
      <path d="M17 17v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1" />
      <path d="M7 11h10" />
      <path d="M7 7v5" />
      <path d="M17 7v5" />
      <path d="M7 17h10" />
      <path d="M12 11v6" />
    </svg>
  ),
  Atelier: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 21h18" />
      <path d="M5 21V11l7-4 7 4v10" />
      <path d="M5 11l7-4 7 4" />
      <path d="M9 21v-8a2 2 0 012-2h2a2 2 0 012 2v8" />
      <path d="M12 9v4" />
      <path d="M12 17v1" />
    </svg>
  ),
};

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

const FAQ = () => {
  const [faqItems, setFaqItems] = useState([]);
  const [categories, setCategories] = useState(["Toutes"]);
  const [selectedCategory, setSelectedCategory] = useState("Toutes");
  const [activeIndex, setActiveIndex] = useState(null);
  const [error, setError] = useState("");
  const { scrollYProgress } = useScroll();
  const yPos = useTransform(scrollYProgress, [0, 1], [0, -100]);
  const scale = useTransform(scrollYProgress, [0, 0.5], [1, 1.03]);

  const fetchFaqs = async (category = "Toutes") => {
    try {
      setError("");
      const url =
        category === "Toutes"
          ? `${apiUrl}/api/faq`
          : `${apiUrl}/api/faq?category=${encodeURIComponent(category.trim())}`;

      const res = await axios.get(url);
      setFaqItems(res.data);

      if (category === "Toutes" && res.data.length > 0) {
        const cats = Array.from(new Set(res.data.map((faq) => faq.category)));
        setCategories(["Toutes", ...cats]);
      }
    } catch (err) {
      console.error("Erreur lors du chargement des FAQs :", err);
      setError(
        "Impossible de charger les questions pour le moment. Veuillez réessayer plus tard."
      );
    }
  };

  useEffect(() => {
    fetchFaqs(selectedCategory);
  }, [selectedCategory]);

  const toggleFAQ = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
    if (activeIndex !== index) {
      setTimeout(() => {
        const el = document.getElementById(`faq-${index}`);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;800;900&family=Cormorant+Garamond:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600;700&display=swap');
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          margin: 0;
          padding: 0;
          overflow-x: hidden;
          font-family: 'Cormorant Garamond', serif;
          background: linear-gradient(135deg, #f8f5f0 0%, #f0ebe0 100%);
        }

        .faq-container {
          font-family: 'Cormorant Garamond', serif;
          color: #2c1810;
          margin: 0 auto;
          overflow-x: hidden;
          background: linear-gradient(135deg, #f8f5f0 0%, #f0ebe0 100%);
        }

        /* Hero Section */
        .hero-section {
          position: relative;
          height: 100vh;
          min-height: 600px;
          background-image: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('${faqHero}');
          background-size: cover;
          background-position: center;
          background-attachment: fixed;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: white;
          text-align: center;
          margin-bottom: 60px;
        }

        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.3);
          backdrop-filter: blur(5px);
        }

        .hero-content {
          position: relative;
          z-index: 2;
          padding: 0 20px;
          max-width: 800px;
        }

        .hero-title {
          font-size: 3.5rem;
          font-weight: 600;
          margin-bottom: 20px;
          letter-spacing: 1px;
          text-shadow: 2px 2px 8px rgba(0,0,0,0.6);
          font-family: 'Cormorant Garamond', serif;
          line-height: 1.2;
        }

        .hero-subtitle {
          font-size: 1.3rem;
          color: rgba(255,255,255,0.95);
          max-width: 700px;
          line-height: 1.6;
          text-shadow: 1px 1px 3px rgba(0,0,0,0.3);
          margin-bottom: 40px;
          font-family: 'Cormorant Garamond', serif;
        }

        .scroll-indicator {
          margin-top: 40px;
          width: 50px;
          height: 50px;
          border: 1px solid rgba(255,255,255,0.7);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
          background: rgba(255, 255, 255, 0.1);
        }

        .scroll-indicator:hover {
          transform: scale(1.05);
          background-color: rgba(255,255,255,0.2);
        }

        .scroll-arrow {
          color: white;
          font-size: 20px;
        }

        /* Main Content */
        .main-content {
          max-width: 1000px;
          margin: 0 auto;
          padding: 0 25px 80px 25px;
        }

        .error-message {
          color: #d32f2f;
          text-align: center;
          margin-bottom: 20px;
          font-weight: 600;
          font-family: 'Cormorant Garamond', serif;
        }

        /* Category Filter */
        .category-filter {
          display: flex;
          flex-wrap: wrap;
          gap: 15px;
          justify-content: center;
          margin-bottom: 50px;
          position: relative;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(212, 175, 55, 0.1);
          border-radius: 20px;
          padding: 30px;
        }

        .category-button {
          padding: 12px 24px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          color: #2c1810;
          border: 1px solid rgba(212, 175, 55, 0.2);
          border-radius: 15px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 10px;
          font-family: 'Cormorant Garamond', serif;
        }

        .category-button.active {
          background: rgba(212, 175, 55, 0.2);
          color: #2c1810;
          border-color: rgba(212, 175, 55, 0.4);
          box-shadow: 0 4px 16px rgba(212, 175, 55, 0.2);
        }

        .category-button:hover {
          transform: translateY(-2px);
          background: rgba(212, 175, 55, 0.1);
        }

        .category-icon {
          width: 18px;
          height: 18px;
          color: #d4af37;
        }

        /* FAQ List */
        .faq-list {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .faq-item {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(212, 175, 55, 0.2);
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .faq-item:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
        }

        .faq-header {
          padding: 25px 30px;
          display: flex;
          align-items: center;
          cursor: pointer;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }

        .faq-header:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .faq-header.active {
          background: rgba(212, 175, 55, 0.1);
        }

        .faq-icon {
          width: 28px;
          height: 28px;
          margin-right: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: #d4af37;
        }

        .faq-content {
          flex: 1;
        }

        .faq-question {
          font-size: 18px;
          font-weight: 600;
          color: #2c1810;
          margin: 0 0 8px 0;
          letter-spacing: 0.2px;
          font-family: 'Cormorant Garamond', serif;
        }

        .faq-category {
          font-size: 14px;
          color: #5a4a3a;
          margin: 0;
          letter-spacing: 0.3px;
          font-family: 'Cormorant Garamond', serif;
        }

        .faq-toggle {
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #d4af37;
          flex-shrink: 0;
          background: rgba(212, 175, 55, 0.1);
          border-radius: 50%;
          transition: all 0.3s ease;
        }

        .faq-answer {
          padding: 0 30px 30px 80px;
          color: #5a4a3a;
          line-height: 1.6;
          font-size: 16px;
          border-top: 1px solid rgba(212, 175, 55, 0.1);
          font-family: 'Cormorant Garamond', serif;
        }

        /* Contact Section */
        .contact-section {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(212, 175, 55, 0.2);
          border-radius: 20px;
          padding: 50px 40px;
          margin-top: 80px;
          text-align: center;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          position: relative;
          overflow: hidden;
        }

        .contact-title {
          font-size: 2.5rem;
          font-weight: 600;
          color: #2c1810;
          margin-bottom: 20px;
          position: relative;
          z-index: 1;
          font-family: 'Cormorant Garamond', serif;
          letter-spacing: 0.5px;
        }

        .contact-text {
          font-size: 1.1rem;
          color: #5a4a3a;
          max-width: 600px;
          margin: 0 auto 35px auto;
          line-height: 1.6;
          position: relative;
          z-index: 1;
          letter-spacing: 0.2px;
          font-family: 'Cormorant Garamond', serif;
        }

        .contact-button {
          padding: 15px 30px;
          background: rgba(212, 175, 55, 0.2);
          color: #2c1810;
          border: 1px solid rgba(212, 175, 55, 0.3);
          border-radius: 15px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          box-shadow: 0 4px 16px rgba(212, 175, 55, 0.2);
          transition: all 0.3s ease;
          letter-spacing: 0.5px;
          position: relative;
          overflow: hidden;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          font-family: 'Cormorant Garamond', serif;
          text-transform: uppercase;
        }

        .contact-button:hover {
          background: rgba(212, 175, 55, 0.3);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(212, 175, 55, 0.3);
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .hero-title {
            font-size: 2.5rem;
          }

          .hero-subtitle {
            font-size: 1.1rem;
          }

          .contact-title {
            font-size: 2rem;
          }

          .main-content {
            padding: 0 20px 60px 20px;
          }

          .faq-header {
            padding: 20px 25px;
          }

          .faq-answer {
            padding: 0 25px 25px 70px;
          }

          .contact-section {
            padding: 40px 30px;
          }

          .category-filter {
            padding: 25px;
          }
        }

        @media (max-width: 480px) {
          .hero-title {
            font-size: 2rem;
            letter-spacing: 1px;
          }

          .hero-subtitle {
            font-size: 1rem;
          }

          .category-button {
            padding: 10px 20px;
            font-size: 13px;
          }

          .faq-question {
            font-size: 16px;
          }

          .faq-answer {
            font-size: 15px;
          }
        }
      `}</style>

      <div className="faq-container">
        {/* Hero Section */}
        <motion.div
          style={{
            y: yPos,
            scale,
          }}
          className="hero-section"
        >
          <div className="hero-overlay" />
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 1 }}
            className="hero-content"
          >
            <motion.h1
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="hero-title"
            >
              Questions Fréquentes
            </motion.h1>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.6 }}
              className="hero-subtitle"
            >
              Trouvez les réponses à vos questions sur notre savoir-faire
              artisanal
            </motion.p>
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 1, type: "spring" }}
              className="scroll-indicator"
              whileHover={{
                scale: 1.1,
                backgroundColor: "rgba(255,255,255,0.1)",
              }}
              onClick={() => {
                window.scrollTo({
                  top: window.innerHeight,
                  behavior: "smooth",
                });
              }}
              style={{ cursor: "pointer" }}
            >
              <motion.span
                animate={{ y: [0, 8, 0] }}
                transition={{
                  repeat: Infinity,
                  duration: 1.5,
                  ease: "easeInOut",
                }}
                className="scroll-arrow"
              >
                ↓
              </motion.span>
            </motion.div>
          </motion.div>
        </motion.div>

        {/* Main Content */}
        <div className="main-content">
          {error && <p className="error-message">{error}</p>}

          {/* Category Filter */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="category-filter"
          >
            {categories.map((category, index) => (
              <motion.button
                key={index}
                whileHover={{
                  y: -3,
                  backgroundColor:
                    selectedCategory === category
                      ? "#3a3226"
                      : "rgba(212, 201, 188, 0.2)",
                  transition: { duration: 0.2 },
                }}
                whileTap={{ scale: 0.96 }}
                onClick={() => setSelectedCategory(category)}
                className={`category-button ${
                  selectedCategory === category ? "active" : ""
                }`}
              >
                {category !== "Toutes" && (
                  <div className="category-icon">{CategoryIcons[category]}</div>
                )}
                {category}
              </motion.button>
            ))}
          </motion.div>

          {/* FAQ List */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="faq-list"
          >
            {faqItems.map((item, index) => (
              <motion.div
                key={item._id || index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05, duration: 0.5 }}
                viewport={{ once: true }}
                className="faq-item"
                id={`faq-${index}`}
              >
                <motion.div
                  onClick={() => toggleFAQ(index)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      toggleFAQ(index);
                    }
                  }}
                  className={`faq-header ${
                    activeIndex === index ? "active" : ""
                  }`}
                  whileHover={{ backgroundColor: "rgba(250, 247, 243, 0.4)" }}
                >
                  <div className="faq-icon">{CategoryIcons[item.category]}</div>
                  <div className="faq-content">
                    <h3 className="faq-question">{item.question}</h3>
                    <p className="faq-category">{item.category}</p>
                  </div>
                  <motion.div
                    animate={{ rotate: activeIndex === index ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="faq-toggle"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </motion.div>
                </motion.div>
                <AnimatePresence>
                  {activeIndex === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      style={{ overflow: "hidden" }}
                    >
                      <div className="faq-answer">{item.answer}</div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </motion.div>

          {/* Contact Section */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            viewport={{ once: true }}
            className="contact-section"
          >
            <motion.h3
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
              viewport={{ once: true }}
              className="contact-title"
            >
              Une question particulière ?
            </motion.h3>

            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
              viewport={{ once: true }}
              className="contact-text"
            >
              Notre équipe d'artisans se fera un plaisir de vous conseiller
              personnellement.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.8 }}
              viewport={{ once: true }}
            >
              <Link to="/contact" style={{ textDecoration: "none" }}>
                <motion.button
                  whileHover={{
                    scale: 1.03,
                    boxShadow: "0 8px 20px rgba(58, 50, 38, 0.2)",
                  }}
                  whileTap={{ scale: 0.98 }}
                  className="contact-button"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
                  </svg>
                  Contactez nos artisans
                </motion.button>
              </Link>
            </motion.div>
          </motion.div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default FAQ;
